(function () {
  const idr = new Intl.NumberFormat('id-ID');

  function formatCurrency(value) {
    return 'Rp ' + idr.format(Math.max(0, Math.round(value)));
  }

  function trimNumber(value) {
    const rounded = Math.round(value * 10) / 10;
    return (Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1)).replace('.', ',');
  }

  function formatShort(value) {
    if (value >= 1000000000) return 'Rp ' + trimNumber(value / 1000000000) + ' Miliar';
    if (value >= 1000000) return 'Rp ' + trimNumber(value / 1000000) + ' Juta';
    if (value >= 1000) return 'Rp ' + trimNumber(value / 1000) + ' Ribu';
    return formatCurrency(value);
  }

  function parseDigits(value) {
    const digits = String(value || '').replace(/\D+/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function tweenNumber(element, fromValue, toValue, formatter, duration) {
    if (!element) return;
    const start = performance.now();
    function frame(now) {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      element.textContent = formatter(fromValue + (toValue - fromValue) * eased);
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function buildMicrocopy(saved) {
  if (saved <= 0) {
    return 'Di angka ini, selisih biayanya belum terlalu besar. Tapi dengan website sendiri, kamu tetap bisa <b>punya data customer sendiri</b> dan kontrol penuh atas pengalaman belanja brand kamu.';
  }

  const short = formatShort(saved);

  let suggestion = 'kamu bisa alokasikan ulang ke <b>marketing</b>, <b>konten</b>, atau <b>peningkatan layanan</b>';

  if (saved >= 100000000) {
    suggestion = 'kamu bisa hire tim marketing internal, tambah inventory, atau scale ads <b>3x lipat</b>';
  } else if (saved >= 50000000) {
    suggestion = 'kamu bisa tambah budget ads, hire tim baru, atau scale brand <b>2x lebih agresif</b>';
  } else if (saved >= 20000000) {
    suggestion = 'kamu bisa <b>tambah budget ads</b>, produksi konten lebih rutin, atau hire 3–4 staff operasional';
  } else if (saved >= 5000000) {
    suggestion = 'kamu bisa alokasikan untuk <b>ads, content production, atau tools growth</b>';
  }

  return 'Dengan <b>' + short + '/bulan</b>, ' + suggestion + '. Bukan cuma habis ke fee marketplace.';
}

  function initReveal(root) {
    root.classList.add('mlp-js-ready');
    const items = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  }

  function initSmoothScroll(root) {
    root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        const id = anchor.getAttribute('href');
        if (!id || id.length <= 1) return;
        const target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 60;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  }

  function initCalculator(root) {
    if (!root.hasAttribute('data-mlp-calculator')) return;
    const omzetEl = root.querySelector('[data-mlp-omzet]');
    const feeEl = root.querySelector('[data-mlp-fee]');
    const feeValueEl = root.querySelector('[data-mlp-fee-value]');
    const mpOmzetEl = root.querySelector('[data-mlp-mp-omzet]');
    const mpFeeDisplayEl = root.querySelector('[data-mlp-mp-fee]');
    const mpRevenueEl = root.querySelector('[data-mlp-mp-revenue]');
    const webOmzetEl = root.querySelector('[data-mlp-web-omzet]');
    const webSubsEl = root.querySelector('[data-mlp-web-subs]');
    const webFeeEl = root.querySelector('[data-mlp-web-fee]');
    const webRevenueEl = root.querySelector('[data-mlp-web-revenue]');
    const savedProfitEl = root.querySelector('[data-mlp-saved-profit]');
    const microcopyEl = root.querySelector('[data-mlp-microcopy]');
    if (!omzetEl || !feeEl) return;

    const webSubs = parseFloat(root.getAttribute('data-web-subs')) || 833333;
    const webFeePct = parseFloat(root.getAttribute('data-web-fee')) || 5;
    let currentMpRevenue = 0;
    let currentWebRevenue = 0;
    let currentSaved = 0;

    function formatFeeNumber(value) {
      return value % 1 === 0 ? String(value) : value.toFixed(1);
    }

    function clampFee(value) {
      const min = parseFloat(feeEl.min) || 0;
      const max = parseFloat(feeEl.max) || 100;
      return Math.min(max, Math.max(min, value));
    }

    function recalc() {
      const omzet = parseDigits(omzetEl.value);
      const mpFee = parseFloat(feeEl.value) || 0;
      const mpRevenue = omzet * (1 - mpFee / 100);
      const webRevenue = omzet * (1 - webFeePct / 100) - webSubs;
      const saved = Math.max(0, webRevenue - mpRevenue);
      const feeNumber = formatFeeNumber(mpFee);
      const feeText = feeNumber + '%';
      const pct = ((mpFee - parseFloat(feeEl.min)) / (parseFloat(feeEl.max) - parseFloat(feeEl.min))) * 100;
      feeEl.style.setProperty('--rangeP', pct + '%');
      if (feeValueEl) {
        if ('value' in feeValueEl && document.activeElement !== feeValueEl) feeValueEl.value = feeNumber;
        else if (!('value' in feeValueEl)) feeValueEl.textContent = feeText;
      }
      if (mpFeeDisplayEl) mpFeeDisplayEl.textContent = feeText;
      if (mpOmzetEl) mpOmzetEl.textContent = formatCurrency(omzet);
      if (webOmzetEl) webOmzetEl.textContent = formatCurrency(omzet);
      if (webSubsEl) webSubsEl.textContent = formatCurrency(webSubs);
      if (webFeeEl) webFeeEl.textContent = (webFeePct % 1 === 0 ? webFeePct : webFeePct.toFixed(1)) + '%';
      tweenNumber(mpRevenueEl, currentMpRevenue, mpRevenue, formatCurrency, 500);
      tweenNumber(webRevenueEl, currentWebRevenue, webRevenue, formatCurrency, 500);
      tweenNumber(savedProfitEl, currentSaved, saved, formatCurrency, 500);
      [mpRevenueEl, webRevenueEl, savedProfitEl].forEach((element) => {
        if (!element) return;
        element.classList.remove('flash');
        void element.offsetWidth;
        element.classList.add('flash');
      });
      if (microcopyEl) microcopyEl.innerHTML = buildMicrocopy(saved);
      currentMpRevenue = mpRevenue;
      currentWebRevenue = webRevenue;
      currentSaved = saved;
    }

    omzetEl.addEventListener('input', () => {
      const caret = omzetEl.selectionStart;
      const before = omzetEl.value;
      const formatted = idr.format(parseDigits(before));
      omzetEl.value = formatted;
      const diff = formatted.length - before.length;
      try { omzetEl.setSelectionRange(caret + diff, caret + diff); } catch (error) {}
      recalc();
    });
    omzetEl.addEventListener('blur', recalc);
    feeEl.addEventListener('input', recalc);
    if (feeValueEl && 'value' in feeValueEl) {
      feeValueEl.addEventListener('input', () => {
        const value = parseFloat(feeValueEl.value);
        const min = parseFloat(feeEl.min) || 0;
        const max = parseFloat(feeEl.max) || 100;
        if (!Number.isFinite(value) || value < min || value > max) return;
        feeEl.value = String(value);
        recalc();
      });
      feeValueEl.addEventListener('blur', () => {
        const value = parseFloat(feeValueEl.value);
        const fallback = parseFloat(feeEl.value) || parseFloat(feeEl.min) || 0;
        const nextValue = Number.isFinite(value) ? clampFee(value) : fallback;
        feeEl.value = String(nextValue);
        feeValueEl.value = formatFeeNumber(nextValue);
        recalc();
      });
      feeValueEl.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') feeValueEl.blur();
      });
    }
    omzetEl.value = idr.format(parseDigits(omzetEl.value));
    recalc();
  }

  function init() {
    document.querySelectorAll('.migrate-landing-page:not([data-mlp-initialized])').forEach((root) => {
      root.setAttribute('data-mlp-initialized', 'true');
      initReveal(root);
      initSmoothScroll(root);
      initCalculator(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
